import { isEqual } from 'lodash-es'

export const normalizeFilterValue = <T = unknown>(value: T): string | string[] | T => {
  if (Array.isArray(value)) {
    if (value.every((item) => typeof item === 'number')) {
      return value.map((item) => item.toString()).toSorted()
    }

    if (value.every((item) => typeof item === 'string')) {
      return value.toSorted()
    }

    return value
  }

  if (typeof value === 'number') {
    return value.toString()
  }

  if (typeof value === 'boolean') {
    return value ? '1' : '0'
  }

  if (value === null) {
    return ''
  }

  return value
}

export const isSameFilterValue = (a: unknown, b: unknown): boolean =>
  isEqual(normalizeFilterValue(a), normalizeFilterValue(b))
